import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Typography, Form, Input, Col, Row } from 'antd';
import { HYPHEN } from '../../../../utilities/constants';
import textAreaCharacterCount from '../../../../components/TextAreaCharacterCount/TextAreaCharacterCount';
import SOModalLayout from './SOModalLayout';
const { Text } = Typography;
const { TextArea } = Input;

const SOResolutionModal = ({
  isModalOpen,
  setIsModalOpen,
  clickedSosData,
  updateSOSList,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  return (
    <SOModalLayout
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      form={form}
      type={'resolution'}
      loading={loading}
      setLoading={setLoading}
      title={'Ticket resolution form'}
      footerButtonText={'Resolve'}
      clickedSosData={clickedSosData}
      updateSOSList={updateSOSList}
    >
      <Row className="full-width">
        <Col xs={24} lg={12}>
          <Flex vertical>
            <Text strong>Reporter</Text>
            <Text>{clickedSosData?.reporter}</Text>
          </Flex>
        </Col>
      </Row>
      <Row
        className="full-width"
        gutter={[
          { xs: 0, lg: 10 },
          { xs: 10, lg: 10 },
        ]}
      >
        <Col xs={24} lg={12} style={{ paddingLeft: 0 }}>
          <Flex vertical>
            <Text strong style={{ marginTop: '4px' }}>
              Call Type
            </Text>
            <Text>{clickedSosData?.call_type || HYPHEN}</Text>
          </Flex>
        </Col>
        <Col xs={24} lg={12} style={{ paddingRight: 0 }}>
          <Flex vertical>
            <Text strong style={{ marginTop: '4px' }}>
              SOS Type
            </Text>
            <Text>
              {clickedSosData?.reason || clickedSosData?.sos_type || HYPHEN}
            </Text>
          </Flex>
        </Col>
      </Row>
      <Row className="full-width">
        <Col xs={24} lg={24}>
          <Flex vertical>
            <Text strong style={{ marginTop: '4px' }}>
              Description
            </Text>
            <Text>{clickedSosData?.description || HYPHEN}</Text>
          </Flex>
        </Col>
      </Row>
      <Row className="full-width">
        <Col xs={24} lg={12}>
          <Form.Item
            name="resolved_by"
            rules={[
              {
                required: true,
                message: 'Please enter resolved by',
              },
            ]}
            label={
              <Text strong style={{ marginTop: '4px' }}>
                Resolved By
              </Text>
            }
          >
            <Input autoSize placeholder="e.g: John Doe" />
          </Form.Item>
        </Col>
      </Row>
      <Row className="full-width">
        <Col xs={24} lg={24}>
          <Form.Item
            name="comments"
            className="message-form-item-modal"
            rules={[
              {
                required: true,
                message: 'Please enter comments',
              },
            ]}
            label={
              <Text strong style={{ marginTop: '4px' }}>
                Comments
              </Text>
            }
          >
            <TextArea
              autoSize
              placeholder="Type your message here&#10;e.g: sample"
              rows={4}
              maxLength={500}
              count={{
                max: 500,
                show: textAreaCharacterCount,
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </SOModalLayout>
  );
};

SOResolutionModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  clickedSosData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  updateSOSList: PropTypes.func.isRequired,
};

export default React.memo(SOResolutionModal);
